import { render, staticRenderFns } from "./ScienceIntegrityItem.vue?vue&type=template&id=61ad97de&scoped=true&"
import script from "./ScienceIntegrityItem.vue?vue&type=script&lang=js&"
export * from "./ScienceIntegrityItem.vue?vue&type=script&lang=js&"
import style0 from "./ScienceIntegrityItem.vue?vue&type=style&index=0&id=61ad97de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad97de",
  null
  
)

export default component.exports